import { render, staticRenderFns } from "./companyPriceListCreateModal.vue?vue&type=template&id=701808a5&"
import script from "./companyPriceListCreateModal.vue?vue&type=script&lang=ts&"
export * from "./companyPriceListCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports